import BotaoImprimir from 'portaltransparencia-common/components/BotaoImprimir.react.js';

import Panel from 'portaltransparencia-common/components/Panel.react.js';
import { addFilterUrl } from 'portaltransparencia-common/libs/AddFilter.js';
import { getAllValuesFromUrlSearchParams } from 'portaltransparencia-common/libs/URLUtils';
import PropTypes from 'prop-types';
import React from 'react';
import { Helmet } from 'react-helmet';
import Component from 'react-pure-render/component';
import { connect } from 'react-redux';
import PageHeader from '../../components/PageHeader.react.js';
import CabecalhoEntidade from '../../entidades/CabecalhoEntidade.react.js';
import * as actions from '../Actions.js';
import CargoDetalheQuadroSalarialOxy from './CargoDetalheQuadroSalarialOxy.react';
import CargoServidores from '../CargoServidores.react.js';

export class CargoQuadroSalarialOxy extends Component {
  static propTypes = {
    location: PropTypes.object.isRequired,
    getCargoDetalhe: PropTypes.func.isRequired
  };

  componentDidMount() {
    const { location } = this.props;

    const params = getAllValuesFromUrlSearchParams(location);

    this.consultarCargos(params);
  }

  consultarCargos = params => {
    const { getCargoDetalhe } = this.props;

    let filtro = '';

    if (params) {
      filtro = addFilterUrl(filtro, `id=${params.cargo}`);
    }

    getCargoDetalhe(filtro);
  };

  renderTable = cargoDetalhe => {
    return (
      <>
        {
          <Panel
            title={`${cargoDetalhe
              .get('cargo')
              .get('quadroSalarialDescricao')}`}
            expansible={false}
            tableResponsive
          >
            <div className="panel-table-outer">
              <table className="panel-table striped fancy">
                <thead>
                  <tr>
                    <th>Faixas</th>
                    <th className="right">Valor</th>
                  </tr>
                </thead>
                <tbody>
                  {cargoDetalhe.get('faixas').map((faixa, index) => (
                    <tr key={index}>
                      <td>{faixa.get('faixaDescricao')}</td>
                      <td className="right">
                        {faixa.get('valor').toLocaleString('pt-br', {
                          minimumFractionDigits: 2
                        })}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </Panel>
        }
      </>
    );
  };

  getCargo = item => {
    const leiCriacao = item.get('leiCriacao');
    return {
      id: item.get('id'),
      entidade: item.get('entidade'),
      descricao: item.get('descricao'),
      cargoTipo: item.get('cargoTipo'),
      quadroSalarialDescricao: item.get('quadroSalarialDescricao'),
      quadroSalarialPath: item.get('quadroSalarialPath'),
      quantidadeVagas: item.get('quantidadeVagas'),
      quantidadeVagasOcupadas: item.get('quantidadeVagasOcupadas'),
      quantidadeVagasDisponiveis: item.get('quantidadeVagasDisponiveis'),
      ...(leiCriacao && { leiCriacao })
    };
  };

  render() {
    const { cargoDetalhe } = this.props;

    if (!cargoDetalhe.get('faixas') || cargoDetalhe.get('faixas').isEmpty()) {
      return (
        <div>
          <Helmet title={'Cargo'} />

          <PageHeader
            location={this.props.location}
            textoDetalhe="Cargo sem plano salarial"
          />

          <div className="info">Cargo sem informação de plano salarial.</div>
        </div>
      );
    }
    const cargo = this.getCargo(cargoDetalhe.get('cargo'));

    return (
      <div>
        <PageHeader location={this.props.location} textoDetalhe="Cargo" />

        <BotaoImprimir />

        <CabecalhoEntidade />

        <CargoDetalheQuadroSalarialOxy cargo={cargo} />

        {this.renderTable(cargoDetalhe)}

        <CargoServidores
          cargoId={getAllValuesFromUrlSearchParams(this.props.location).cargo}
        />
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    cargoDetalhe: state.cargo.get('cargoDetalheOxy')
  };
}

const allActions = {
  ...actions
};

export default connect(mapStateToProps, allActions)(CargoQuadroSalarialOxy);
